import { styled as e } from "styled-components";
import { H3Heavy as t } from "../../../../styles/typography/index.js";
const p = e.div`
  ${t}
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 8px 16px 8px;

  i {
    cursor: pointer;
    font-size: 24px;
  }
`;
export {
  p as Title
};
